export default __webpack_public_path__ + "media/flags/cn-03403229.svg";